import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/refresh.svg'
import _imports_1 from '@/app/ui/assets/svg/bg-sti-summary-stt.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-right-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-76859f9a")

_pushScopeId("data-v-76859f9a")
const _hoisted_1 = { class: "relative bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen w-full" }
const _hoisted_2 = { class: "flex z-20" }
const _hoisted_3 = { class: "font-semibold self-center mr-10 text-20px whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_4 = { class: "overflow-auto h-screen" }
const _hoisted_5 = { class: "flex flex-col w-full mt-4 pb-1" }
const _hoisted_6 = { class: "flex justify-end items-center " }
const _hoisted_7 = { class: "text-14px font-montserrat font-normal text-gray-500" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_0
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "absolute top-0 right-0 bottom-0 object-cover h-full",
  src: _imports_1
}, null, -1)
const _hoisted_10 = { class: "flex flex-col w-4/5" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = { class: "font-montserrat font-bold line-height-075 text-20px" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "ml-2",
  src: _imports_2
}, null, -1)
const _hoisted_14 = { class: "flex flex-row mt-4" }
const _hoisted_15 = { class: "font-montserrat font-bold line-height-075 text-60px" }
const _hoisted_16 = { class: "font-montserrat font-bold line-height-075 text-34px mt-5 ml-4" }
const _hoisted_17 = { class: "flex flex-col w-1/5 mt-6" }
const _hoisted_18 = { class: "font-montserrat font-bold line-height-075 text-20px" }
const _hoisted_19 = { class: "flex flex-row mt-4 mb-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Header = _resolveComponent("Header")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { class: "items-center" }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getTitle), 1)
        ]),
        (_ctx.ableToCreate)
          ? (_openBlock(), _createBlock(_component_lp_button, {
              key: 0,
              onClick: _ctx.goToUpdate,
              title: _ctx.$t('stiSc.list.buttonUpdate'),
              textColor: "white"
            }, null, 8, ["onClick", "title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('stiSc.list.dataRefreshNote')), 1),
          _hoisted_8,
          _createVNode("div", {
            class: "text-14px font-montserrat font-normal text-red-500 ml-1 cursor-pointer underline",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRefreshSTISCSummary && _ctx.onRefreshSTISCSummary(...args)))
          }, _toDisplayString(_ctx.$t('stiSc.list.refresh')), 1)
        ]),
        _createVNode("div", {
          class: "background-gradient-red text-white px-6 pt-4 pb-6 rounded-lg shadow-lg w-full flex justify-between items-center cursor-pointer relative",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoNeedToStiSCPage && _ctx.gotoNeedToStiSCPage(...args)))
        }, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('stiSc.list.bannerTotalPending')), 1),
              _hoisted_13
            ]),
            _withDirectives(_createVNode(_component_skeleton, {
              class: "mt-3",
              width: "340px",
              height: "62px"
            }, null, 512), [
              [_vShow, _ctx.isLoadingSTTSummary]
            ]),
            _withDirectives(_createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatSTTNumber(_ctx.STISCSTTDueSummaryData.totalBooked)), 1),
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('stiSc.list.posPerClient')), 1)
            ], 512), [
              [_vShow, !_ctx.isLoadingSTTSummary]
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('stiSc.list.bannerCurrentStiSc')), 1),
            _withDirectives(_createVNode(_component_skeleton, {
              class: "mt-3",
              width: "156px",
              height: "41px"
            }, null, 512), [
              [_vShow, _ctx.isLoadingSTTSummary]
            ]),
            _withDirectives(_createVNode("div", { class: "font-montserrat font-bold line-height-075 text-34px mt-3" }, _toDisplayString(_ctx.formatSTTNumber(_ctx.STISCSTTDueSummaryData.totalNow + _ctx.STISCSTTDueSummaryData.totalOverdue)) + " " + _toDisplayString(_ctx.$t('stiSc.common.unitStt')), 513), [
              [_vShow, !_ctx.isLoadingSTTSummary]
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode(_component_Search, {
          class: "w-64 self-center",
          onInput: _ctx.onSearch,
          onClear: _ctx.clearSearch,
          value: _ctx.searchValue,
          placeholder: _ctx.$t('stiSc.list.searchManifestIdPlaceholder'),
          minChar: 1,
          timeout: 1000
        }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
        _createVNode(_component_time_range_picker, {
          startDate: _ctx.periodeStart,
          endDate: _ctx.periodeEnd,
          onSelect: _ctx.setPeriode,
          default: _ctx.$t('stiSc.list.last7Days')
        }, null, 8, ["startDate", "endDate", "onSelect", "default"])
      ]),
      (_ctx.stiSCList.length === 0 && !_ctx.periodeStart && !_ctx.periodeEnd)
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 0,
            data: "STI-SC"
          }))
        : (_openBlock(), _createBlock(_component_TableV2, {
            key: 1,
            columns: _ctx.columns,
            data: _ctx.stiSCList,
            loading: _ctx.isLoading,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event)),
            onRequest: _ctx.fetchStiSCList,
            errorCause: _ctx.errorCause,
            totalColumnFreeze: 1,
            paginationStyle: "v3"
          }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause"]))
    ])
  ]))
})